(function (namespace, $) {
    "use strict";

    var AppSimulator = function () {
        var o = this;

        jQuery(document).ready(function () {
            o.initialize();
        });

    };

    var p = AppSimulator.prototype;

    p._messages;
    p._view;
    p._viewOption;

    p.initialize = function () {
        var o = this;

        o._messages = [];
        o._view = '';
        o._viewOption = '';

        var field;
        var option;
        var type;

        jQuery('body').delegate('#button-main', 'click', function () {
            jQuery('#simulator-main').css({display: 'none'});
            jQuery('#simulator-menu').css({display: 'block'});
        });

        jQuery('body').delegate('#button-back-menu', 'click', function () {
            jQuery('#simulator-main').css({display: 'block'});
            jQuery('#simulator-menu').css({display: 'none'});
        });

        jQuery('body').delegate('#button-back-forms', 'click', function () {
            jQuery('#simulator-forms').css({display: 'none'});
            jQuery('#simulator-menu').css({display: 'block'});
        });

        jQuery('body').delegate('#button-forms', 'click', function () {
            jQuery('#simulator-forms').css({display: 'block'});
            jQuery('#simulator-menu').css({display: 'none'});
        });

        jQuery('body').delegate('#button-messages', 'click', function () {
            jQuery('#simulator-messages').css({display: 'block'});
            jQuery('#simulator-forms').css({display: 'none'});
            o.populateMessages();
            o.setMessageSend(true);
        });

        jQuery('body').delegate('.button-message-select', 'click', function () {
            jQuery('#simulator-message').css({display: 'block'});
            jQuery('#simulator-messages').css({display: 'none'});
            o.populateMessage($(this).data('id'));
        });

        jQuery('body').delegate('#button-back-message', 'click', function () {
            jQuery('#simulator-message').css({display: 'none'});
            jQuery('#simulator-messages').css({display: 'block'});
        });

        jQuery('body').delegate('#button-back-messages', 'click', function () {
            jQuery('#simulator-messages').css({display: 'none'});
            jQuery('#simulator-forms').css({display: 'block'});
        });

        jQuery('body').delegate('.button-up-scroll', 'click', function () {
            o.scrollMove(jQuery('#' + $(this).data('form')), -100);
        });

        jQuery('body').delegate('.button-down-scroll', 'click', function () {
            o.scrollMove(jQuery('#' + $(this).data('form')), 100);
        });

        jQuery('body').delegate('.button-forms-select', 'click', function () {
            var div = jQuery('#'+ jQuery(this).attr('data-form'));
            var forms = jQuery('#simulator-forms');
            forms.addClass('simulator-form');
            o._view = forms.html();
            forms.html(div.html());
        });

        jQuery('body').delegate('.button-discart', 'click', function () {
            o.closeForm();
        });

        jQuery('body').delegate('.button-sent', 'click', function () {
            var values = [];
            jQuery('#' + $(this).data('form') + ' .values').each(function() {
                values.push({
                    title: $(this).data('title'),
                    value: $(this).text()
                });
            });
            o._messages.push({title: $(this).data('title'), values: values, date: o.getDate(), send: false});
            o.closeForm();
        });

        jQuery('body').delegate('.button-option-cancel', 'click', function () {
            o.closeFormOption();
        });

        jQuery('body').delegate('.button-option-save', 'click', function () {
            var value = [];
            if (type === 'multiple-select-type') {
                jQuery('input[name=' + option + ']:checked').each(function () {
                    value.push($(this).val());
                });
            } else {
                value.push(jQuery('input[name=' + option + ']:checked').val());
            }
            o.closeFormOption();
            jQuery('#'+field).text(value.toString());
        });

        jQuery('body').delegate('.button-form-select', 'click', function () {
            field = jQuery(this).data('id');
            type = jQuery(this).data('type');
            switch (type) {
                case 'int-numpad-type':
                    jQuery('#simulator-numpad').css({display: 'block'});
                    jQuery('#simulator-input').css({display: 'block'}).focus();
                    jQuery('#simulator-forms').css({display: 'none'});
                    break;
                case 'multiple-select-type':
                    option = 'option-' + jQuery(this).data('id');
                    o.openFormOption(jQuery(this).data('id'));
                    break;
                case 'single-select-type':
                    option = 'option-' + jQuery(this).data('id');
                    o.openFormOption(jQuery(this).data('id'));
                    break;
                default:
                    jQuery('#simulator-keyboard').css({display: 'block'});
                    jQuery('#simulator-input').css({display: 'block'}).focus();
                    jQuery('#simulator-forms').css({display: 'none'});

            }
        });

        jQuery('body').delegate('#button-keyboard-back, #button-numpad-back', 'click', function () {
            o.closeKeyboard();
        });

        jQuery('body').delegate('#button-keyboard-confirm, #button-numpad-confirm', 'click', function () {
            jQuery('#'+field).text(jQuery('#simulator-input').val());
            o.closeKeyboard();
        });
    };

    p.scrollMove = function (e, number) {
        var scrolled = e.scrollTop();
        e.animate({ scrollTop: scrolled + number });
    };

    p.closeForm = function () {
        var o = this;
        jQuery('#simulator-forms').html(o._view);
        jQuery('#simulator-forms').removeClass('simulator-form');
    };

    p.closeFormOption = function () {
        var o = this;
        jQuery('#simulator-forms').html(o._viewOption);
        jQuery('#simulator-forms').removeClass('simulator-option');
    };

    p.openFormOption = function (id) {
        var o = this;
        var div = jQuery('#simulator-option-' + id);
        var forms = jQuery('#simulator-forms');
        forms.addClass('simulator-option');
        o._viewOption = forms.html();
        forms.html(div.html());
    };

    p.closeKeyboard = function () {
        jQuery('#simulator-input').val('');
        jQuery('#simulator-input').css({display: 'none'});
        jQuery('#simulator-keyboard').css({display: 'none'});
        jQuery('#simulator-numpad').css({display: 'none'});
        jQuery('#simulator-forms').css({display: 'block'});
    };

    p.getDate = function () {
        var date = new Date();
        return date.getUTCDate()
            + '/' + (date.getMonth()+1)
            + '/' + date.getFullYear()
            + ' ' + date.getHours()
            + ":" + date.getMinutes();
    };

    p.populateMessages = function () {
        var o = this;

        var html = '';
        for (var i = o._messages.length -1; i >= 0; i--) {
            html += "<div class='button button-content button-message-select' data-id='"+ i +"'>";
            html += "<div class='content-field-title'>";
            html += o._messages[i].title;
            html += "</div>";
            html += "<div class='content-field-value'>";
            html += o._messages[i].date;
            html += (o._messages[i].send) ? ' Enviado' : ' Enviando';
            html += "</div>";
            html += "</div>";
        }

        jQuery('#simulator-messages-content-main').html(html);
    };

    p.populateMessage = function (index) {
        var o = this;

        var html = "<div class='button button-content'>";
        html += "<div class='content-field-title'>";
        html += o._messages[index].title;
        html += "</div>";
        html += "<div class='content-field-value'>";
        html += o._messages[index].date;
        html += "</div>";
        html += "</div>";

        for (var i = 0; i < o._messages[index].values.length; i++) {
            html += "<div class='button button-content'>";
            html += "<div class='content-field-title'>";
            html += o._messages[index].values[i].title;
            html += "</div>";
            html += "<div class='content-field-value'>";
            html += o._messages[index].values[i].value;
            html += "</div>";
            html += "</div>";
        }

        jQuery('#simulator-message-content-main').html(html);
    };

    p.setMessageSend = function (b) {
        var o = this;
        if (o._messages.length > 0 && !o._messages[o._messages.length - 1].send) {
            jQuery.each(o._messages, function () {
                this.send = b;
            });
            setTimeout(function () {
                o.refreshMessages(o._messages);
            }, 10000);
        }
    };

    p.refreshMessages = function (messages) {
        var o = this;
        o._messages = messages;
        o.populateMessages();
    };

    window.gpssat.AppSimulator = new AppSimulator;
}(window.gpssat, jQuery));